import { HEALTH_STATUS_TAB } from "../../framework/tab/tabUtilsConstants";

export const initial_state_health_status = {
  type: HEALTH_STATUS_TAB,
  label: "Health Status",
  allowMultipleTabs: false,
};
